function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from "prop-types";
import React from "react";
import Base from "../Base/Base";
import Modal from "../Modal/Modal";
import AlertDialogContext from "./AlertDialogContext";
import "./AlertDialog.css";
export default function AlertDialog({
  children,
  onRequestClose,
  type = "info",
  ...rest
}) {
  return /*#__PURE__*/React.createElement(Modal, _extends({}, rest, {
    onOverlayClick: onRequestClose,
    overlayShade: null
  }), /*#__PURE__*/React.createElement(Base, {
    className: "ax-alert-dialog"
  }, /*#__PURE__*/React.createElement(AlertDialogContext.Provider, {
    value: {
      onRequestClose,
      type
    }
  }, children)));
}